import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { MailRecordEntity } from './mail-record.entity';

@Index('_mail_read', ['fkMailRecordId', 'workdUserId'], {})
@Entity('_mail_user_status')
export class MailUserStatusEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__mail_record__id',
		nullable: true,
		unsigned: true,
	})
	public fkMailRecordId!: number | null;

	@Column('int', { name: '_workd__user__id', unsigned: true })
	public workdUserId!: number;

	@Column('tinyint', { name: '_read', width: 1, default: () => "'0'" })
	public read!: boolean;

	@ManyToOne(
		() => MailRecordEntity,
		(mailRecord) => mailRecord.mailUserStatuses,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: '_fk__mail_record__id', referencedColumnName: 'id' }])
	public fkMailRecord!: MailRecordEntity;
}
